// removed by extract-text-webpack-plugin
module.exports = {"component":"M1_vqZfypaQ1wRtX3rX1N","modalContent":"_1evVAkYapQ9aeWc6kRhERJ","header":"n9OVclnVlsI0UryXjbhQc","title":"_26_CE5uNwRtq2tH7V0Iboz","tail":"_1pCc1TazHvm92pIF5xpHHa","item":"_3JuHgtXq2qrgyb1PaCCk8q","checkbox":"_1qFwcg6mdEEccRmLiG8oe3","close":"_3F2MlubSF85JK5XpxtFZXA","zhuan_a":"_3ZdlR-TpWE1LmHGi1Ztqs8","zhuan":"_37r6oBtjITYL21oLBtZ9B1"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ServicesModal/ServicesModal.scss
 ** module id = 1034
 ** module chunks = 0
 **/